"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

mouse.register({
  down: (x, y) => {
  },
  move: (x, y, dx, dy) => {
  },
  up: (x, y) => {
  },
})

*/

var fns = {
  down: [],
  move: [],
  drag: [],
  up: []
};

document.body.scrollTo(0, 0);
document.body.parentNode.scrollTo(0, 0);
document.body.addEventListener("scroll", function (e) {
  e.preventDefault();
});
document.body.parentNode.addEventListener("scroll", function (e) {
  e.preventDefault();
});

exports.default = {
  register: function register(callbacks) {
    callbacks.down && fns.down.push(callbacks.down);
    callbacks.move && fns.move.push(callbacks.move);
    callbacks.drag && fns.drag.push(callbacks.drag);
    callbacks.up && fns.up.push(callbacks.up);
  }
};


var x = void 0,
    y = void 0,
    dragging = false;

function down(e) {
  x = e.pageX;
  y = e.pageY;
  x /= window.innerWidth;
  y /= window.innerHeight;
  dragging = true;
  fns.down.map(function (f) {
    return f(x, y);
  });
}
function move(e) {
  var dx = e.pageX - x;
  var dy = e.pageY - y;
  x = e.pageX;
  y = e.pageY;
  x /= window.innerWidth;
  y /= window.innerHeight;
  fns.move.map(function (f) {
    return f(x, y, dx, dy);
  });
  dragging && fns.drag.map(function (f) {
    return f(x, y, dx, dy);
  });
}
function up(e) {
  dragging = false;
  fns.up.map(function (f) {
    return f(x, y);
  });
}

function touch(f) {
  return function (e) {
    e.preventDefault();
    f(e.touches[0]);
  };
}
document.body.addEventListener("mousedown", down);
document.body.addEventListener("mousemove", move);
window.addEventListener("mouseup", up);
document.body.addEventListener("touchstart", touch(down));
document.body.addEventListener("touchmove", touch(move));
document.body.addEventListener("touchup", touch(up));


//////////////////
// WEBPACK FOOTER
// ./client/lib/mouse.js
// module id = 26
// module chunks = 0